const temas = [
    {
        id: 'claro',
        label: 'Claro',
        icono: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />,
    },
    {
        id: 'oscuro',
        label: 'Oscuro',
        icono: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />,
    },
    {
        id: 'sistema',
        label: 'Automático',
        icono: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />,
    },
];

const vistas = [
    {
        id: 'selector',
        titulo: 'Selector de precio',
        descripcion: 'Elegís Público o Mayorista y la lista 1, 2 o 3. Se muestra un precio grande.',
        preview: (
            <div className="space-y-1.5">
                <div className="flex gap-0.5 rounded-md bg-slate-200/70 p-0.5 dark:bg-slate-700">
                    <span className="h-3 flex-1 rounded bg-white shadow-sm dark:bg-slate-500" />
                    <span className="h-3 flex-1 rounded" />
                </div>
                <div className="flex gap-0.5 rounded-md bg-slate-200/70 p-0.5 dark:bg-slate-700">
                    <span className="h-3 flex-1 rounded bg-white shadow-sm dark:bg-slate-500" />
                    <span className="h-3 flex-1 rounded" />
                    <span className="h-3 flex-1 rounded" />
                </div>
                <div className="flex h-8 items-center justify-center rounded-md bg-brand-50 ring-1 ring-brand-100 dark:bg-brand-950 dark:ring-brand-900">
                    <span className="h-2.5 w-14 rounded bg-slate-700 dark:bg-slate-300" />
                </div>
                <span className="block h-4 rounded-md bg-[#25D366]" />
            </div>
        ),
    },
    {
        id: 'lista',
        titulo: 'Lista completa',
        descripcion: 'Los 6 precios a la vista, cada uno con su botón de WhatsApp.',
        preview: (
            <div className="space-y-1">
                {[0, 1, 2, 3, 4, 5].map((i) => (
                    <div key={i} className={`flex items-center gap-1 ${i === 3 ? 'mt-1.5' : ''}`}>
                        <span className="h-3 w-3 rounded bg-slate-200 dark:bg-slate-700" />
                        <span className="h-2 flex-1 rounded bg-slate-300 dark:bg-slate-600" />
                        <span className="h-3 w-3 rounded bg-[#25D366]" />
                    </div>
                ))}
            </div>
        ),
    },
];

export default function Configuracion({ vistaModal, cambiarVistaModal, tema, cambiarTema, cerrar }) {

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) cerrar();
    };

    return (
        <div
            onClick={handleOverlayClick}
            className="fixed inset-0 z-[120] flex items-center justify-center bg-slate-900/60 p-4 backdrop-blur-sm animate-fade-in dark:bg-black/70"
        >
            <div role="dialog" aria-modal="true" className="flex max-h-[90dvh] w-full max-w-md flex-col overflow-hidden rounded-2xl bg-white shadow-2xl animate-sheet-up dark:bg-slate-900 dark:ring-1 dark:ring-slate-800">
                <div className="flex items-center justify-between gap-4 px-5 pb-2 pt-4">
                    <h2 className="text-lg font-semibold text-slate-900 dark:text-white">Configuración</h2>
                    <button
                        onClick={cerrar}
                        aria-label="Cerrar"
                        className="-mr-2 flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-slate-400 transition hover:bg-slate-100 hover:text-slate-600 dark:text-slate-500 dark:hover:bg-slate-800 dark:hover:text-slate-200"
                    >
                        <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div className="space-y-5 overflow-y-auto px-5 pb-5">
                    {/* Apariencia */}
                    <section>
                        <h3 className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Apariencia</h3>
                        <div className="flex gap-1 rounded-xl bg-slate-100 p-1 dark:bg-slate-800" role="radiogroup" aria-label="Tema">
                            {temas.map((t) => {
                                const activo = tema === t.id;
                                return (
                                    <button
                                        key={t.id}
                                        role="radio"
                                        aria-checked={activo}
                                        onClick={() => cambiarTema(t.id)}
                                        className={`flex h-10 flex-1 items-center justify-center gap-1.5 rounded-lg text-sm font-semibold transition ${activo
                                            ? 'bg-white text-slate-900 shadow-sm ring-1 ring-slate-200 dark:bg-slate-700 dark:text-white dark:ring-slate-600'
                                            : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'}`}
                                    >
                                        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">{t.icono}</svg>
                                        {t.label}
                                    </button>
                                );
                            })}
                        </div>
                    </section>

                    {/* Vista del detalle */}
                    <section>
                        <h3 className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Detalle del artículo</h3>
                        <div className="grid grid-cols-2 gap-3" role="radiogroup" aria-label="Vista del detalle">
                            {vistas.map((op) => {
                                const activo = vistaModal === op.id;
                                return (
                                    <button
                                        key={op.id}
                                        role="radio"
                                        aria-checked={activo}
                                        onClick={() => cambiarVistaModal(op.id)}
                                        className={`flex flex-col rounded-xl border-2 p-3 text-left transition active:scale-[0.98] ${activo
                                            ? 'border-brand-500 bg-brand-50/40 dark:border-brand-500 dark:bg-brand-950/40'
                                            : 'border-slate-200 hover:border-slate-300 dark:border-slate-700 dark:hover:border-slate-600'}`}
                                    >
                                        <div className="mb-3 rounded-lg border border-slate-200 bg-white p-2.5 dark:border-slate-700 dark:bg-slate-800/60">
                                            {op.preview}
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <span className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 ${activo ? 'border-brand-600 dark:border-brand-400' : 'border-slate-300 dark:border-slate-600'}`}>
                                                {activo && <span className="h-2 w-2 rounded-full bg-brand-600 dark:bg-brand-400" />}
                                            </span>
                                            <p className="text-sm font-semibold leading-tight text-slate-900 dark:text-white">{op.titulo}</p>
                                        </div>
                                        <p className="mt-1 text-xs leading-snug text-slate-500 dark:text-slate-400">{op.descripcion}</p>
                                    </button>
                                );
                            })}
                        </div>
                    </section>
                </div>

                <div className="border-t border-slate-100 bg-slate-50 px-5 py-3 dark:border-slate-800 dark:bg-slate-900">
                    <button
                        onClick={cerrar}
                        className="h-11 w-full rounded-xl bg-brand-600 text-sm font-semibold text-white shadow-sm transition hover:bg-brand-700 active:scale-[0.99]"
                    >
                        Listo
                    </button>
                </div>
            </div>
        </div>
    );
}
